import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { AnimatePresence, motion, useIsPresent } from 'framer-motion';
import { useDefaultLayout } from 'hooks/useDefaultLayout';
import { Button } from '@daedalus/atlas/Button';
import { Icon } from '@daedalus/atlas/Icon';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { StickyWrapper } from './styles';
import useBackToTop from './useBackToTop';
interface Props {
  onClick: () => void;
  enabled: boolean;
  verticalOffset?: number;
}
// We'll float it outside when there is enough space to fit + space up to the window edge
// match PageWidthContainer

const ButtonsWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonsWrapper",
  class: "b1moktkf",
  propsAsIs: false
});
const BackToTopButton = ({
  onClick,
  enabled = true
}: Props) => {
  const dispatch = useDispatch();
  const showBackToTop = useBackToTop(enabled);
  const isPresent = useIsPresent();
  const {
    isMapVisible
  } = useDefaultLayout();
  useEffect(() => {
    if (showBackToTop && isPresent) {
      dispatch(trackEvent({
        category: Category.User,
        entity: Entity.BackToTopButton,
        action: Action.Viewed
      }));
    }
  }, [isPresent, showBackToTop]);
  const onBackToTopClick = () => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.BackToTopButton,
      action: Action.Clicked
    }));
    onClick();
  };
  return <StickyWrapper>
      <AnimatePresence>
        {showBackToTop && <motion.div key="backToTop" initial={{
        opacity: 0,
        y: 100
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 100
      }} transition={{
        duration: 0.15
      }}>
            <ButtonsWrapper className={cx(!isMapVisible && '__notMapVisible')}>
              <Button isRounded isFloating variant="secondary" onClick={onBackToTopClick} iconStart={<Icon name="ArrowUp" />} />
            </ButtonsWrapper>
          </motion.div>}
      </AnimatePresence>
    </StickyWrapper>;
};
export default BackToTopButton;

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");